import { ReactNode, useCallback, useState } from 'react';
import { useToggle } from '@shared/util/hooks';
import { useUpgrade } from '../metricsCounter/useUpgrade';
import { UpgradeContent, UpgradeContentProps, UpgradeModal } from './UpgradeModal';
import { type ShowModalOptions, UpgradeModalContextProvider } from './context';

interface Props {
  children: ReactNode;
}

export function UpgradeModalProvider({ children }: Props) {
  const [modalProps, setModalProps] = useState<ShowModalOptions>({
    title: '',
    description: '',
    onLearnMore: undefined,
    header: undefined,
    hideUpgradeButton: false,
  });
  const upgrade = useUpgrade();
  const { isOn, toggleOn, toggleOff } = useToggle();

  const show = useCallback(
    ({
      title,
      description,
      header = undefined,
      hideUpgradeButton,
      onLearnMore,
    }: ShowModalOptions) => {
      setModalProps({ title, description, header, hideUpgradeButton, onLearnMore });
      toggleOn();
    },
    [toggleOn],
  );

  return (
    <UpgradeModalContextProvider value={{ show }}>
      {children}
      <UpgradeModal
        visible={isOn}
        onClose={toggleOff}
        onUpgrade={modalProps.hideUpgradeButton ? () => {} : upgrade}
        {...modalProps}
      />
    </UpgradeModalContextProvider>
  );
}

export function UpgradeInlineContent({
  hideUpgradeButton,
  ...props
}: Omit<UpgradeContentProps, 'onUpgrade'> & { hideUpgradeButton?: boolean }) {
  const upgrade = useUpgrade();
  return <UpgradeContent {...props} onUpgrade={hideUpgradeButton ? undefined : upgrade} />;
}
